import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {Observable} from "rxjs";
import BasePtpForm from "../base-ptp-form";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-audit-log",
    templateUrl: "./audit-log.component.html",
    styleUrl: "./audit-log.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuditLogComponent extends BasePtpForm implements OnInit {
    constructor(
        api: PerFormaAPIService,
        private route: ActivatedRoute
    ) {
        super(api);
    }

    PTPItem: any = {};
    PTPItemID;
    PTPItemType;

    Refresh() {
        this.getData();
    }

    ngOnInit(): void {
        // get the query params
        const params = new URL(window.location.toString()).searchParams;

        const show = params.get("show") ?? "";

        if (show != "") {
            this.DoScroll = true;
            this.ScrollTo = show;
        }

        this.route.queryParams.subscribe(f => {
            this.PTPItemID = f.poid;
            this.PTPItemType = f.itemtype;
            this.getData();
        });
    }

    getData = () => {
        this.Loading = true;

        const data$: Observable<any> =
            this.PTPItemType === "0"
                ? this.api.getApiPTPGetPORequest({poRequestId: this.PTPItemID})
                : this.api.getApiPTPGetPO({poId: this.PTPItemID});

        data$.subscribe(data => {
            this.PTPItem = data;
            this.Loading = false;

            // see if we need to scroll
            if (this.DoScroll && this.ScrollTo?.length > 0) {
                setTimeout(() => {
                    this.ScrollToElement(this.ScrollTo);
                }, 500);
            }
        });
    };
}
